import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { WalletProvider } from './contexts/WalletContext'
import { ToastProvider } from './contexts/ToastContext'
import Home from './pages/Home'
import MatchDetail from './pages/MatchDetail'
import MyDuels from './pages/MyDuels'
import Profile from './pages/Profile'
import Tournaments from './pages/Tournaments'
import JudgePanel from './pages/JudgePanel'
import FinishMatch from './pages/FinishMatch'

function App() {
  return (
    <WalletProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/match/:matchId" element={<MatchDetail />} />
            <Route path="/my-duels" element={<MyDuels />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/judge" element={<JudgePanel />} />
            <Route path="/judge/finish/:matchId" element={<FinishMatch />} />
          </Routes>
        </Router>
      </ToastProvider>
    </WalletProvider>
  )
}

export default App

